import { render, staticRenderFns } from "./EModalConfirmacao.vue?vue&type=template&id=dadefd4a"
import script from "./EModalConfirmacao.vue?vue&type=script&lang=js"
export * from "./EModalConfirmacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports